import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const MaterialMeanDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'material-mean',
        routeParamKey: 'materialMeanId',
        pageTitle: 'MaterialMean Details',
        backRoute: '/material-means',
        backLabel: 'Back to MaterialMeans',
        tabIdPrefix: 'material-mean',
        tabsAriaLabel: 'material-mean detail tabs',
        missingIdMessage: 'No material-mean ID provided in the URL.',
        noDataMessage: 'No material-mean data available. The material-mean might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default MaterialMeanDetailPage;
